import { roundNumber } from './math';

export const getRandomNumberWithinRange = (min: number, max: number) => {
  return roundNumber(Math.random() * (max - min) + min, 0);
};
